/**
 * External Dependencies
 */
import Controller from './helpers/Controller';

// import app from './config/app';

import common from './controllers/common';
import Collapse from './components/Collapse';
import Dropdown from './components/Dropdown';
import Tab from './components/Tab';
// import templateHome from './controllers/templateHome';
// import AlertComponent from './components/AlertComponent';
// import BannerComponent from './components/BannerComponent';

const modules = [
    common,
    Collapse,
    Dropdown,
    Tab,
    // templateHome,
    // AlertComponent,
    // BannerComponent,
];
const controller = new Controller(modules);
controller.ready();

// @note - this will popup a confirmation before leaving the page
// window.onbeforeunload = () => controller.destroy();
